import { injectGlobal } from '@emotion/css';

import InterSemiBold from './resources/Inter-SemiBold.woff';
import InterMedium from './resources/Inter-Medium.woff';
import InterRegular from './resources/Inter-Regular.woff';
import InterLight from './resources/Inter-Light-BETA.woff';
import VirginMoneyLoopRegular from './resources/VirginMoneyLoop-Regular.woff';
import VirginMoneyLoopLight from './resources/VirginMoneyLoop-Light.woff';
import VirginMoneySansMedium from './resources/VirginMoneySans-Medium.woff';
import VirginMoneySansRegular from './resources/VirginMoneySans-Regular.woff';
import VirginMoneySansLight from './resources/VirginMoneySans-Light.woff';

injectGlobal(`
  @font-face {
    font-family: 'Inter';
    src: local('Inter'), url(${InterSemiBold}) format('woff');
    font-weight: 600;
  }
  @font-face {
    font-family: 'Inter';
    src: local('Inter'), url(${InterMedium}) format('woff');
    font-weight: 500;
  }
  @font-face {
    font-family: 'Inter';
    src: local('Inter'), url(${InterRegular}) format('woff');
    font-weight: 400;
  }
  @font-face {
    font-family: 'Inter';
    src: local('Inter'), url(${InterLight}) format('woff');
    font-weight: 300;
  }
  @font-face {
    font-family: 'VirginMoneyLoop';
    src: local('VirginMoneyLoop'), url(${VirginMoneyLoopRegular}) format('woff');
    font-weight: 400;
  }
  @font-face {
    font-family: 'VirginMoneyLoop';
    src: local('VirginMoneyLoop'), url(${VirginMoneyLoopLight}) format('woff');
    font-weight: 300;
  }
  @font-face {
    font-family: 'VirginMoneySans';
    src: local('VirginMoneySans'), url(${VirginMoneySansMedium}) format('woff');
    font-weight: 500;
  }
  @font-face {
    font-family: 'VirginMoneySans';
    src: local('VirginMoneySans'), url(${VirginMoneySansRegular}) format('woff');
    font-weight: 400;
  }
  @font-face {
    font-family: 'VirginMoneySans';
    src: local('VirginMoneySans'), url(${VirginMoneySansLight}) format('woff');
    font-weight: 300;
  }
`);

injectGlobal(`
  :root {
    --font-body: 'Inter', Helvetica, Arial, sans-serif;
    --font-heading: 'VirginMoneySans', Helvetica, Arial, sans-serif;
    --font-heading-light: 'VirginMoneySansLight', Helvetica, Arial, sans-serif;
    --font-loop: 'VirginMoneyLoop', Helvetica, Arial, sans-serif;
    --font-weight-boldest: 900;
    --font-weight-bolder: 800;
    --font-weight-bold: 700;
    --font-weight-semi-bold: 600;
    --font-weight-medium: 500;
    --font-weight-regular: 400;
    --font-weight-light: 300;
    --font-weight-lighter: 200;
    --font-weight-thin: 100;
  }
`);
